<template>
  <div>
    <sgcq-topbar />
    <sgcq-sidebar />
    <sgcq-tabspanel />
  </div>
</template>

<script>
import SgcqTopBar from "@/components/bars/SgcqTopBar.vue";
import SgcqSideBar from "@/components/bars/SgcqSideBar.vue";
import SgcqTabsPanel from "@/components/tabs/SgcqTabsPanel";

export default {
  name: "PaginaDoSgcq",

  components: {
    "sgcq-topbar": SgcqTopBar,
    "sgcq-sidebar": SgcqSideBar,
    "sgcq-tabspanel": SgcqTabsPanel,
  },

};
</script>

<style lang="scss" scoped></style>
